import apiFetch from '../apiFetch'

export default function (ouId, token) {
  return apiFetch({ endPoint: `DossierType/UO/${ouId}`, method: 'GET', body: null, token: token })
}
